import { CheckCircleOutline } from "@mui/icons-material";
import { Box, Stack, Typography } from "@mui/material";
import { Button } from "../../buttons/Button";

interface IProps {
    /**
     * callback to close the dialog
     */
    onClose: () => void;
    /**
     * The description of the success message
     */
    description: string;
}

/**
 * Success message after creating or updating a project folder
 */
export const DialogMutationSuccess = ({ onClose, description }: IProps) => {
    return (
        <>
            <CheckCircleOutline
                color={"success"}
                sx={{ width: 48, height: 48 }}
            />
            <Stack alignItems={"center"}>
                <Typography variant="h6" fontWeight={600}>
                    Success
                </Typography>

                <Typography variant={"body2"} color={"textSecondary"}>
                    {description}
                </Typography>
            </Stack>

            <Box flexGrow={1} />

            <Box>
                <Button
                    type="button"
                    variant="outlined"
                    color="darkSharp"
                    sx={{ borderRadius: 2, py: 1, minWidth: 180 }}
                    fullWidth
                    onClick={onClose}
                >
                    Close
                </Button>
            </Box>
        </>
    );
};
